import React,{useState} from 'react';
import Footer from '../components/Footer';

// import Navbar2 from '../components/Navbar2';
import Navbar from '../components/Navbar';
import PremiumRoomPage from '../components/PremiumRoom';

import Sidebar from '../components/Sidebar';


function PremiumRoom() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />  
            <PremiumRoomPage />
            <Footer />
        </div>
    )
}

export default PremiumRoom
